<template>
  <div id="footer" >

    <div class="main">
      <div  @click="reMain" class="img_main">
        <img class="img_logo"  src="../assets/img/22.png" alt="logo图">
      </div>

      <div class="address_tel_fax">
        <p> {{$t('frame.tel')}}：{{this.companyInfo.tel}}</p>
        <p> {{$t('frame.email')}}：{{this.companyInfo.emile}}</p>
        <p>{{$t('frame.weixin')}}：{{this.companyInfo.weixin}}</p>
        <p>{{$t('frame.address')}}：{{this.companyInfo.address}}</p>
      </div>
    </div>

    <p class="copy"> Copyright &copy; {{this.companyInfo.companyName}} 陕ICP备2021013735号-1 </p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      companyInfo: JSON.parse(localStorage.getItem('companyData'))
    };
  },

  created(){
    // console.log(localStorage.getItem('companyData'))
    // this.companyInfo = localStorage.getItem('companyData')
    console.log('AAAAAAAAAAAAAAAAAAAAA================',this.companyInfo)
  },

  methods:{
    //刷新页面
    reMain(){
      location.reload()
    },
  }
};
</script>
<style scoped>
#footer {

  padding: 2%;
  width: 100%;
  height: 100%;
  color: #fff;
  background-color:  #222935;
  overflow: hidden;
  background-image: url("../assets/img/footer-bg.png");
  background-size: 100%;
  background-repeat: no-repeat;
}
.main{
  display: flex; align-items: center
}
.img_main{
  margin-left: 46%; float: left; margin-top: 45px
}

.img_logo{
  float: right;
  height: 170px;
  width: 170px;
  margin-left: -80px;
}

.address_tel_fax {

  width: 40%; margin-left: 1%; float: right;
  margin-top: 60px;
  color: #d3d3d3;
  font-size: 15px;

}

.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
  text-align: center;
}
@media screen and (max-width: 997px) {
  .main{
    /*display: flex;*/
    display:inline
  }
  .img_main{
    margin-left: 50%; float: none;
    margin-top: 10px;
  }

  .img_logo{
    margin-top: 0;
    float: none;
    height: 170px;
    width: 170px;
    /*margin-left: -80px;*/
  }
  .address_tel_fax {
    width: 80%;
    float: none;
    margin-top: 0px;
    color: #d3d3d3;
    font-size: 12px;
    margin-left: 10%;

  }

  .copy {
    width: 100%;
    height: auto;
    color: #d3d3d3;
    font-size: 10px;
    bottom: 0px;
    text-align: center;

  }

}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue